module.exports = __webpack_public_path__ + "img/invest_block3.2eb595bf.png";